/**
 * Numeric Reva id for /api/league/tournaments/{id} routes.
 * List endpoints expose Fansbury uuid as `id` and the Reva pk as `revaId`.
 */
export const leagueTournamentApiId = (tournament) => {
  if (tournament == null) return null;
  if (typeof tournament === "object") {
    return tournament.revaId ?? tournament.id;
  }
  return tournament;
};

export const leagueTournamentRelationshipId = (tournament) => {
  const apiId = leagueTournamentApiId(tournament);
  return apiId == null ? null : String(apiId);
};

export const tournamentMatchesRelationship = (tournament, relationshipId) =>
  String(leagueTournamentApiId(tournament)) === String(relationshipId);
